export default __webpack_public_path__ + "static/media/section-noten.cd7bf321.png";